import {Grid, makeStyles, Table, TableBody, TableCell, TableContainer, TableRow, Typography} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import React, {useContext} from 'react';
import {InvoiceListDataContext} from '../InvoiceListDataContextProvider';
import MuiAlert from '@material-ui/lab/Alert';
import TableHeader from '../../../components/table/TableHeader';
import {Skeleton} from '@material-ui/lab';
import TablePagination from '../../../components/table/Pagination';
import InvoiceRow from './InvoiceRow';

type InvoiceTableProps = {
  showPagination: Boolean;
};

const useStyles = makeStyles((theme) => ({
  skeleton: {
    height: '200px',
  },
  main: {
    padding: theme.spacing(1),
  },
}));

export function InvoiceTable({ showPagination }: InvoiceTableProps) {
  const { t } = useTranslation(['debitors', 'invoices']);

  const classes = useStyles();

  const context = useContext(InvoiceListDataContext);

  const preColumns = !context.isPrefilteredForDebtor
    ? [
        {
          label: t('status'),
          id: 'status',
        },
        {
          label: t('customer'),
          id: 'debitor',
        },
      ]
    : [
        {
          label: t('status'),
          id: 'status',
        },
      ];

  const columns = preColumns.concat([
    {
      label: t('amount'),
      id: 'total',
    },
    {
      label: t('creationDate'),
      id: 'creationDate',
    },
    {
      label: t('invoices:documentNumber'),
      id: 'documentNumber',
    },
    {
      label: t('invoice_type'),
      id: 'invoiceType',
    },
  ]);

  const initalLoad = !context.page && context.loading;
  const emptyResultList = !!context.page && context.invoices && context.invoices.length === 0;
  const emptyFilteredResultList = emptyResultList && context.filters?.used;

  return (
    <>
      {emptyResultList ? (
        <>
          {emptyFilteredResultList ? (
            <Typography style={{ marginTop: '40px' }}>{t('no results for your invoice search')}</Typography>
          ) : (
            <Grid item xs={12} className={classes.main}>
              <MuiAlert elevation={6} variant="filled" severity="warning">
                {t('no invoices yet')}
              </MuiAlert>
            </Grid>
          )}
        </>
      ) : (
        <>
          <TableContainer style={{ flex: '1 1 auto' }}>
            <Table>
              <TableHeader columns={columns} actions={true}></TableHeader>
              <TableBody>
                {initalLoad && (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1}>
                      <Skeleton className={classes.skeleton} />
                    </TableCell>
                  </TableRow>
                )}
                {context.invoices?.map((invoice, index) => (
                  <InvoiceRow invoice={invoice} index={index} key={invoice.id} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {showPagination && <TablePagination transformPageSizeLabel={(pageSize) => t('pageSize', { pageSize: pageSize }) as string} />}
        </>
      )}
    </>
  );
}
